export default "/images/70d27decf763ded407c96b3b70d2f148.avif";